import { Stack, Typography } from '@mui/material';
import { Category, CategoryKey } from '@seatsio/seatsio-react';
import { forwardRef } from 'react';

import CategoryColor from 'components/@seating/CategoryColor';
import FormattedMoneyInfo from 'components/@tickets/FormattedMoneyInfo';

interface Props {
  category: Category;
  selected: boolean;
  onClick: (category: CategoryKey) => void;
}

const CategoryItem = forwardRef<HTMLDivElement, Props>(
  ({ category, selected, onClick }, ref) => {
    const handleClick = () => onClick(category.key);

    return (
      <Stack
        onClick={handleClick}
        ref={ref}
        sx={{
          height: 32,
          display: 'inline-flex',
          border: '1px solid',
          borderColor: selected ? 'grey.400' : 'divider',
          textAlign: 'start',
          alignItems: 'center',
          gap: 0.5,
          p: 1,
          pr: 1.5,
          borderRadius: 4,
          flexDirection: 'row',
          minWidth: 'fit-content',
          cursor: 'pointer',
          userSelect: 'none',

          '&:hover': {
            bgcolor: 'grey.900',
          },

          // Ensures the labels are fully scrolled into the view
          scrollMarginRight: '100px',
        }}
      >
        <CategoryColor color={category.color} selected={selected} />
        <Typography
          variant="extraSmall"
          sx={{
            color: selected ? 'text.secondary' : 'grey.600',
          }}
        >
          <FormattedMoneyInfo price={category.pricing.price} />
        </Typography>
      </Stack>
    );
  },
);

CategoryItem.displayName = 'CategoryItem';

export default CategoryItem;
